<template>
  <div class="cont-time-line">
    <div class="contEvents">
      <transition name="list" mode="out-in">
        <div class="no-detail text-color-primary" v-if="!selectedEvent.detail" key="noDetail">
          <span
            >Presiona un año para conocer detalles acerca de mi &#128102;</span
          >
        </div>
        <div v-else key="detail">
          <view-event :item="selectedEvent" />
        </div>
      </transition>
    </div>
    <svg class="svg-cont" viewBox="0 0 850 300">
      <!-- Linea eje x -->
      <polyline points=" 10,250 810,250" fill="none" stroke="#135583" />
      <!-- Lineas verticales del eje x -->
      <line
        v-for="(year, index) in endYear - startYear"
        :key="index * year"
        class="rect-1"
        :x1="calculateXAxis(year)"
        :y1="245"
        :x2="calculateXAxis(year)"
        :y2="250"
        stroke="gray"
      />
      <!-- Linea vertical de las series -->
      <line
        v-for="(obj, index) in list"
        :key="'lineSeries' + index"
        class="lineSeries"
        :class="{ eventSelected: selectedEvent.start == obj.start }"
        :x1="(obj.start - startYear) * (canvas / totalYears) + 10"
        :x2="(obj.start - startYear) * (canvas / totalYears) + 10"
        :y1="obj.id % 2 == 1 ? 160 - 50 : 160"
        :y2="250"
        @click="selectedPoint(obj)"
      />
      <!-- labels de las series de la linea de tiempo -->
      <text
        v-for="(obj, index) in list"
        :key="'titleSeries' + index"
        :x="(obj.start - startYear) * (canvas / totalYears) - 10"
        :y="obj.id % 2 == 1 ? 150 - 50 : 150"
        class="titleSeries"
        :class="{ eventSelected: selectedEvent.start == obj.start }"
        @click="selectedPoint(obj)"
      >
        {{ obj.start }}
      </text>
    </svg>
  </div>
</template>

<script>
import ViewEvent from "./viewEvent.vue";
export default {
  components: {
    ViewEvent
  },
  props: {
    list: Array
  },
  data: function() {
    return {
      startYear: 2012,
      endYear: 2024,
      canvas: 800,
      selectedEvent: {}
    };
  },
  methods: {
    calculateXAxis: function(year) {
      /**
             *  Para hallar el valor en px correspondiente a cada año se usa la fórmula:
                ((canvas/(endYear-startYear))*year)+10
                donde:
                - canvas son el total de px
                - (endYear-startYear) son el total de años en el eje X
                - year es el número consecutivo asignado a cada año (1,2,3,4,5...)
                - 10 es una constante de px que se debe sumar porque la gráfica no arranca en 0 sino 10 px a la derecha
            */
      return (this.canvas / this.totalYears) * year + 10;
    },
    selectedPoint: function(obj) {
      this.selectedEvent = obj;
    }
  },
  computed: {
    totalYears: function() {
      /**
       * Calcula el total de años transcurridos entre el primer y el último septenio
       */
      return this.endYear - this.startYear;
    }
  }
};
</script>

<style>
.cont-time-line {
  width: 95%;
  margin: 0 auto;
  transition: all 0.5s;
}
.contEvents {
  width: 100%;
}
.svg-cont {
  width: 70%;
  height: 300px;
  display: block;
  margin: 0 auto;
}
.titleSeries {
  fill: #66cf9f;
  cursor: pointer;
  font-weight: bold;
  transition: font-size 0.5s;
}
.titleSeries:hover {
  font-size: 18px;
}
.lineSeries {
  cursor: pointer;
  stroke: #66cf9f;
  stroke-width: 25px;
}

.no-detail {
  text-align: center;
  width: 100%;
}
.eventSelected {
  fill: #0d8d53;
  font-size: 18px;
  text-decoration-line: underline;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.5s;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
